import { useCallback, useMemo, useState } from 'react'

import { useResizeObserver } from './useResizeObserver'

interface Size {
  width: number | undefined
  height: number | undefined
}

export const useSize = ({
  element,
  delay = 500
}: {
  element?: HTMLElement | null
  delay?: number
}): Size => {
  const [size, setSize] = useState<Size>({
    width: undefined,
    height: undefined
  })

  const handleResize = useCallback(() => {
    const width = element?.clientWidth
    const height = element?.clientHeight
    setSize((prev) =>
      prev.width === width && prev.height === height ? prev : { width, height }
    )
  }, [element])

  const elements = useMemo(() => [element], [element])

  useResizeObserver({
    delay,
    elements: elements,
    onResize: handleResize
  })

  return size
}
